import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { PartnerProfilePageContainer } from "./PartnerProfilePageContainer";
import { Card, Col, Container, Row, Form } from "react-bootstrap";
import defaultImg from "../../assets/images/imagePlaceholder.png";
import { useSelector } from "react-redux";
import {
  FcViewDetails,
  FcSimCardChip,
  FcDatabase,
  FcCopyright,
  FcBookmark,
  FcBusinesswoman,
  FcManager,
} from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import { smaartCardUrl } from "../../constant";

const PartnerProfilePage = () => {
  const partnerData = useSelector((state) => state.partnerData);
  const [showEmail, setShowEmail] = useState(partnerData?.showEmail || 0);
  const navigate = useNavigate();

  const handleEmailToggle = (newStatus) => {
    // Update UI instantly
    setShowEmail(newStatus);

    // Call API asynchronously
    fetch(
      `${smaartCardUrl}/api/v1/partner/showEmail/changeStatus?partnerid=${partnerData?.partnerId}&status=${newStatus}`,
      {
        method: "POST",
        headers: {
          "X-APIKEY": "dfordr",
          "AgentName": "dfordrapp",
        },
      }
    )
      .then((res) => {
        if (!res.ok) console.error("Failed to update email status");
      })
      .catch((err) => console.error("Error updating email status:", err));
  };

  return (
    <PartnerProfilePageContainer>
      <Header />
      <div className="allContent py-4" style={{ background: "#f8f9fa" }}>
        <Container>
          <Row>
            {/* Profile Card */}
            <Col lg={7}>
              <Card className="shadow-sm rounded-3 mb-4">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src={partnerData?.profilePhoto || defaultImg}
                      alt="Profile"
                      className="rounded-circle"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        marginRight: "20px",
                      }}
                    />
                    <h4 className="mb-0">{partnerData?.name}</h4>
                  </div>

                  <div className="mb-3 d-flex align-items-center">
                    <strong>Email: </strong>
                    <span className="ms-2">
                       {partnerData?.email}  
                    </span>
                    <Form.Check
                      type="switch"
                      id="showEmailSwitch"
                      label={showEmail === 1 ? "Visible" : "Hidden"}
                      checked={showEmail === 1}
                      onChange={() => handleEmailToggle(showEmail === 1 ? 0 : 1)}
                      className="ms-3"
                    />
                  </div>

                  <div className="mb-2">
                    <strong>Mobile No.: </strong>
                    <span>{partnerData?.mobile}</span>
                  </div>
                  <div className="mb-2">
                    <strong>Address: </strong>
                    <span>{partnerData?.address}</span>
                  </div>
                  <div className="mb-2">
                    <strong>Customized Partner: </strong>
                    <span>{partnerData?.isCustomized === 0 ? "Yes" : "No"}</span>
                  </div>
<div className="mb-2">
  <strong>Website Name : </strong>
  <span>{partnerData?.websiteDisplayText }</span>
</div>

<div className="mb-2">
  <strong>Website: </strong>
  {partnerData?.website ? (
    <a
      href={partnerData.website}
      target="_blank"
      rel="noopener noreferrer"
    >
      {partnerData.website}
    </a>
  ) : (
    <span style={{ color: '#999', fontStyle: 'italic' }}>
      Not provided
    </span>
  )}
</div>
                </Card.Body>
              </Card>
            </Col>

            {/* Action Cards */}
            <Col lg={5}>
              <Card
                className="shadow-sm mb-3 action-card"
                onClick={() => navigate("/owned-packages")}
                style={{ cursor: "pointer" }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FcViewDetails style={{ fontSize: "25px", marginRight: "10px" }} />
                  <span>View Owned Packages</span>
                </Card.Body>
              </Card>

              <Card
                className="shadow-sm mb-3 action-card"
                onClick={() => {
                  localStorage.setItem("redeemPartnerId", partnerData?.partnerId);
                  localStorage.setItem("CardNumberVerified", "Redeem");
                  navigate("/redeemDashboard");
                }}
                style={{ cursor: "pointer" }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FcSimCardChip style={{ fontSize: "25px", marginRight: "10px" }} />
                  <span>Redeem</span>
                </Card.Body>
              </Card>

              <Card
                className="shadow-sm mb-3 action-card"
                onClick={() => navigate("/redeemLogs")}
                style={{ cursor: "pointer" }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FcDatabase style={{ fontSize: "25px", marginRight: "10px" }} />
                  <span>Redemption Log</span>
                </Card.Body>
              </Card>

              <Card
                className="shadow-sm mb-3 action-card"
                onClick={() => navigate("/partner-termsandcondition")}
                style={{ cursor: "pointer" }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FcCopyright style={{ fontSize: "25px", marginRight: "10px" }} />
                  <span>Terms & Conditions</span>
                </Card.Body>
                
              </Card>
   <Card
                className="shadow-sm mb-3 action-card"
                onClick={() => navigate("/userLogs")}
                style={{ cursor: "pointer" }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FcManager  style={{ fontSize: "25px", marginRight: "10px" }} />
                  <span>User Logs</span>
                </Card.Body>
                
              </Card>
              {localStorage.getItem("isCustomizedForDeduction") == 1 && (
                <Card
                  className="shadow-sm mb-3 action-card"
                  onClick={() => {
                    localStorage.setItem("redeemPartnerId", partnerData?.partnerId);
                    localStorage.setItem("CardNumberVerified", "DeductionPoints");
                    navigate("/redeemDashboard");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <Card.Body className="d-flex align-items-center">
                    <FcBookmark style={{ fontSize: "25px", marginRight: "10px" }} />
                    <span>Deduction Points</span>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </PartnerProfilePageContainer>
  );
};

export default PartnerProfilePage;
